import script from "./VoiceOverTab.vue?vue&type=script&setup=true&lang=js"
export * from "./VoiceOverTab.vue?vue&type=script&setup=true&lang=js"

import "./VoiceOverTab.vue?vue&type=style&index=0&id=fc148f18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc148f18"]])

export default __exports__